import { Spinner } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import useStores from '../stores/UseStores';
import AddEmailSuccessNotice from './AddEmailSuccessNotice';
import DuplicateProfileNotice from './DuplicateProfileNotice';
import EmailForm from './EmailForm';
import NotSupportedNotice from './NotSupportedNotice';

const AddEmail = observer((): React.JSX.Element => {
  const { addEmailStore } = useStores();
  const { email, fetching, response, sessionValid } = addEmailStore;

  React.useEffect(() => {
    addEmailStore.checkSessionValid();
  }, []);

  if (fetching) {
    return <Spinner />;
  }

  if (response?.duplicateProfileMessage) {
    return <DuplicateProfileNotice message={response?.duplicateProfileMessage} />;
  }

  if (response?.success) {
    return <AddEmailSuccessNotice email={email} />;
  }

  if (sessionValid) {
    return <EmailForm />;
  }

  return <NotSupportedNotice />;
});

export default AddEmail;
